import { GraphConfiguration } from "@/type/common";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Skeleton } from "../ui/skeleton";
import RenderGraph from "./GraphItem/RenderGraph";
import React from "react";
import { useTranslation } from "react-i18next";
import { cleanDomain } from "@/utils/refactor";

const GraphItem = ({
  config,
  data,
  metadata,
  models,
  loaded,
}: {
  config: GraphConfiguration;
  data: any[];
  metadata?: any;
  models: any[];
  loaded: boolean;
}) => {
  const { t } = useTranslation();

  const displayCount = metadata?.total_count ?? 0;
  const showRecordCount = config.graph_options?.showRecordCount ?? true;

  // Handle click on record count badge to navigate to all records
  const handleRecordClick = () => {
    if (config.data_source.sqlRequest) {
      return; // Can't navigate with SQL requests
    }
    if (window.location.href.includes("/edit")) {
      return; // Can't navigate in edit mode
    }

    const target = {
      type: "navigate",
      model: config.model,
      name: models.find((m) => m.value === config.model)?.label,
      domain: cleanDomain(config.data_source.domain || []),
    };

    window.parent.postMessage(target, "*");
  };

  return (
    <Card className="gap-2 h-full w-full overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle>
          {config.title && config.title !== ""
            ? config.title
            : t("editor.graphConfig.data.unNamedGraph")}
        </CardTitle>
        {showRecordCount && displayCount > 0 && (
          <div
            onClick={handleRecordClick}
            className="flex items-center justify-center px-2 py-0.5 border rounded-full cursor-pointer"
          >
            <span className="text-xs font-medium text-muted-foreground my-0">
              {displayCount} {displayCount === 1 ? "record" : "records"}
            </span>
          </div>
        )}
      </CardHeader>
      <CardContent className="flex flex-row items-stretch h-full w-full pt-2 pb-4">
        {!data || (data.length === 0 && !loaded) ? (
          <Skeleton className="w-full h-32" />
        ) : data.length === 0 ? (
          <div className="w-full h-32 flex items-center justify-center">
            No data available
          </div>
        ) : (
          <RenderGraph config={config} data={data} models={models} />
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(GraphItem);
